// MenuManagerWrapper.jsx
import React from 'react';
import BasicMenu from './BasicMenu';
import StandardMenu from './StandardMenu';


const Management2 = ({ plan }) => {
  // Get plan from prop or localStorage
  let subscriptionPlans = plan || JSON.parse(localStorage.getItem("planTypes"));


  //console.log("📦 Raw plan from prop/localStorage:", subscriptionPlans);

  // If no planTypes available, show message
  if (!subscriptionPlans || subscriptionPlans.length === 0) {
    console.warn("⚠️ No planTypes found, menu will not render.");
    return <div>No plan assigned. Please login again.</div>;
  }

  // Ensure it's always an array
  if (!Array.isArray(subscriptionPlans)) {
    subscriptionPlans = [subscriptionPlans];
  }
  //console.log("📦 Normalized plan array:", subscriptionPlans);

  // Normalize to lowercase for comparison
  subscriptionPlans = subscriptionPlans.map(p => p.toLowerCase());
  //console.log("📦 Lowercased plans for comparison:", subscriptionPlans);

  // Prioritize PREMIUM > STANDARD > BASIC
  let selectedPlan = null;
  if (subscriptionPlans.includes("premium")) selectedPlan = "premium";
  else if (subscriptionPlans.includes("standard")) selectedPlan = "standard";
  else if (subscriptionPlans.includes("basic")) selectedPlan = "basic";

  //console.log("🎯 Selected plan to render menu:", selectedPlan);

  // Render menu based on selected plan
  switch (selectedPlan) {
    case "basic":
      return <BasicMenu />;
    case "standard":
      return <StandardMenu />;
    case "premium":
      return <StandardMenu />;
    default:
      return <div>No valid plan assigned</div>;
  }
};

export default Management2;
